import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

import { useLoadData } from '../../../hooks/useLoadData';
import { ApiResponse } from '../../../models/api-response';
import { LoadingIndicator } from '../../../components/loading-indicator.component';
import { leaveManageApiKeyStore } from '../../../api/leave-manage-api-key-store';

interface StatusFilter {
  value?: any;
  onChange: (type: any, value: any) => void;
}
export const StatusFilter = ({ value, onChange }: StatusFilter) => {
  const { data, isLoading } = useLoadData<ApiResponse<any>>(leaveManageApiKeyStore.getLeaveStatus());

  return (
    <>
      <LoadingIndicator isLoading={isLoading} />
      <FormControl fullWidth>
        <InputLabel size="small" id="demo-simple-select-label">
          Status
        </InputLabel>
        <Select
          size="small"
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={value}
          label="Status"
          onChange={(event) => onChange('leaveStatusID', event.target.value)}
        >
          <MenuItem value="">
            <em>NONE</em>
          </MenuItem>

          {data &&
            data?.data.map((o: any) => (
              <MenuItem key={`${o.leaveStatusID}-${o.leaveStatus}`} value={o.leaveStatusID}>
                {o.leaveStatus}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </>
  );
};
